<div class="emoji-box" [ngClass]="{'activityStyle': hostPage === 'activity', 'bottom': inActivityBottom}">
  <div class="inner scroll-bar" [ngStyle]="containerStyle"
    style="padding-top: 8px; padding-right: 0px;padding-left: 2px;">
    <div class="emoji-container" [style.width.px]="currentSet.width === 90 && hostPage === 'activity' ? currentSet.width - 20 : currentSet.width"
      [style.height.px]="currentSet.height === 90 && hostPage === 'activity' ? currentSet.height - 20 : currentSet.height"
      *ngFor="let item of currentSet.items">
      <app-emoji [emoji]="item" [maxWidth]="currentSet.width === 90 && hostPage === 'activity' ? currentSet.width - 20 : currentSet.width"></app-emoji>
    </div>
    <div *ngIf="canNotUseVipEmoj()" class="vip-only d-flex align-items-center justify-content-center">
      <div class="text-center">
        <div class="highlight-text mb-3">仅限VIP会员使用</div>
        <div class="dn-button dn-button-red" (click)="showRechargeBox()">升级VIP</div>
      </div>
    </div>
    <div *ngIf="isOpenLoading" class="loader d-flex align-items-center justify-content-center">
      <app-loader-spinner style="margin-top: 32px;"></app-loader-spinner>
    </div>
  </div>
  <!-- <app-slider [ngStyle]="containerStyle()"
                *ngIf="sliderItems.length && emojiSets.length"
                [sliderItems]="currentSet.pages"
                [sliderStyle]="sliderStyle()"
                [data]="currentSet">
        <div *ngIf="canNotUseVipEmoj()"
             class="vip-only d-flex align-items-center justify-content-center">
            <div class="text-center">
                <div class="highlight-text mb-3">仅限VIP会员使用</div>
                <div class="dn-button dn-button-red"
                     (click)="showRechargeBox()">升级VIP</div>
            </div>
        </div>
        <div class="inner"
             style="padding-top: 8px;">
            <app-slider-item class="d-flex flex-wrap"
                             *ngFor="let slider of sliderItems; let i = index"
                             [Index]="i">
                <div class="emoji-container"
                     [style.width.px]="currentSet.width"
                     [style.height.px]="currentSet.height"
                     *ngFor="let item of currentSet.items.slice((i) * currentSet.pageSize, (i+1) * currentSet.pageSize)">
                    <app-emoji [emoji]="item"></app-emoji>
                </div>
            </app-slider-item>
        </div>
    </app-slider> -->
  <app-tabs [tabs]="tabs" [showShadow]="false" [showHoverShadow]="false" [tabStyle]="tabStyle" [tabsStyle]="tabsStyle"
    [tabActiveStyle]="tabActiveStyle" [tabHoveredStyle]="tabHoveredStyle" (selectTabEvent)="onSelectTab($event)" [hostPage]="hostPage">
  </app-tabs>
</div>
